const Download = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.3379L16 11.3379H13V4.33789H11V11.3379H8L12 16.3379Z"
        fill={color}
      />
      <path
        d="M20 18.3379H4V11.3379H2V18.3379C2 19.4409 2.897 20.3379 4 20.3379H20C21.103 20.3379 22 19.4409 22 18.3379V11.3379H20V18.3379Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Download;
